export default __webpack_public_path__ + "static/media/IMG_2346.44c5b568.jpg";